import axios from './axios';

export const projectUserApi = {
  // Get all users associated with a project
  async getProjectUsers(projectId: number): Promise<number[]> {
    const response = await axios.get(`/user-projects/projects/${projectId}/users`);
    return response.data;
  },

  // Get all projects associated with a user
  async getUserProjects(userId: number): Promise<number[]> {
    const response = await axios.get(`/user-projects/${userId}/projects`);
    return response.data;
  }
};
